import * as React from 'react';
import { themr } from 'react-css-themr';
import { Button, ButtonTypes } from 'common/components/core/button';

import classnames from 'classnames';
import theme from './EntityNotesInput.scss';

class EntityNotesInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            notes: props.notes
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.notes !== this.props.notes) {
            this.setState({ notes: this.props.notes });
        }
    }

    onNotesAddClick = () => {
        this.onChange(notes => notes.push(''));
    };

    onNotesChange = event => {
        const { id, value } = event.target;
        this.onChange(notes => notes.set(id, value));
    };

    handleNoteDelete = event => {
        const { id } = event.target;
        this.onChange(notes => notes.delete(id));
    };

    onChange = callback => {
        const { notes } = this.state;
        const { onChange } = this.props;

        const updatedNotes = callback(notes);
        this.setState({ notes: updatedNotes }, () => {
            onChange && onChange(updatedNotes);
        });
    };

    render() {
        const { notes } = this.state;
        const {
            translationsObject,
            placeholder,
            t,
            addBtnTestId,
            addTextId
        } = this.props;

        return (
            <div>
                {notes.map((note, index) => {
                    return (
                        <div key={index} className={theme.notesWrap}>
                            <div className={theme.titleAndIcon}>
                                <span className={theme.title}>
                                    {t(translationsObject.rowLabel, {
                                        num: index + 1
                                    })}
                                </span>
                                <Button
                                    id={index}
                                    buttonType={ButtonTypes.Icon}
                                    circle
                                    icon="delete-bin"
                                    className={classnames(
                                        theme.btn,
                                        theme.deleteBtn
                                    )}
                                    theme={theme}
                                    onClick={this.handleNoteDelete}
                                />
                            </div>
                            <textarea
                                testId={`${addTextId}-${index}`}
                                value={note}
                                id={index}
                                rows={3}
                                placeholder={t(placeholder)}
                                className={theme.noteInput}
                                onChange={this.onNotesChange}
                            />
                        </div>
                    );
                })}
                <span
                    className={theme.addText}
                    testId={addBtnTestId}
                    onClick={this.onNotesAddClick}
                >
                    {`+ ${t(translationsObject.addBtnText)}`}
                </span>
            </div>
        );
    }
}

export default themr('EntityNotesInput', theme)(EntityNotesInput);
